import React, { useState } from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Input } from "rbx";
import { BooleanInput } from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = { Active: true };

function PaymentTermFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const newFilters = {
      ...inputs
    };
    if (e.target.name === "TariffTypeRecIdRef") {
      const v = parseInt(value);
      newFilters.TariffTypeRecIdRef = v !== 0 ? v : null;
    } else {
      newFilters[e.target.name] = value;
    }
    setInputs(newFilters);
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <Label>Term Code</Label>
              <Input
                expanded
                autocomplete="new"
                name="TermCode_contains"
                type="text"
                value={inputs?.TermCode_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Active</Label>
              <BooleanInput
                name="Active"
                value={inputs.Active}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
PaymentTermFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default PaymentTermFilters;
